const toInfinitive = function (s) {
  s.verbs().toInfinitive()
  // s.compute('chunks')
  return s
}
export default toInfinitive